"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AXSEvent = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Event = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n"], ["\n  font-size: 14px;\n"])));
var EventImage = styled_components_1.default(AXSFlexItem_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  height: 80px;\n  width: 136px;\n\n  @media (max-width: 640px) {\n    display: ", ";\n  }\n"], ["\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  height: 80px;\n  width: 136px;\n\n  @media (max-width: 640px) {\n    display: ",
    ";\n  }\n"])), function (_a) {
    var url = _a.url;
    return "url(" + url + ")";
}, function (_a) {
    var hideImageOnMobile = _a.hideImageOnMobile;
    return hideImageOnMobile ? 'none' : 'block';
});
var EventDetails = styled_components_1.default(AXSFlexItem_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: 18px;\n\n  flex: ", ";\n"], ["\n  line-height: 18px;\n\n  flex: ", ";\n"])), function (_a) {
    var hideImageOnMobile = _a.hideImageOnMobile;
    return (hideImageOnMobile ? '1 0 auto' : '2');
});
var Season = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n"], ["\n  color: ",
    ";\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n"])), function (_a) {
    var seasonColor = _a.seasonColor, theme = _a.theme;
    return utils_1.parseThemePath(seasonColor, theme, colors_1.colors.GREY_650);
});
var EventName = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 17px;\n  font-weight: bold;\n"], ["\n  color: ", ";\n  font-size: 17px;\n  font-weight: bold;\n"])), function (_a) {
    var eventColor = _a.eventColor, theme = _a.theme;
    return utils_1.parseThemePath(eventColor, theme, colors_1.colors.GREY_650);
});
var Extra = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: lighter;\n  line-height: 8px;\n  margin-top: 4px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n  font-weight: lighter;\n  line-height: 8px;\n  margin-top: 4px;\n"])), function (_a) {
    var extraColor = _a.extraColor, theme = _a.theme;
    return utils_1.parseThemePath(extraColor, theme, colors_1.colors.GREY_650);
});
exports.AXSEvent = function (_a) {
    var eventDate = _a.eventDate, eventColor = _a.eventColor, eventImageUrl = _a.eventImageUrl, season = _a.season, seasonColor = _a.seasonColor, eventName = _a.eventName, extra = _a.extra, extraColor = _a.extraColor, theme = _a.theme, className = _a.className, hideImageOnMobile = _a.hideImageOnMobile, props = __rest(_a, ["eventDate", "eventColor", "eventImageUrl", "season", "seasonColor", "eventName", "extra", "extraColor", "theme", "className", "hideImageOnMobile"]);
    return (React.createElement(Event, __assign({}, props, { className: classnames_1.default(['c-axs-event', className]) }),
        eventImageUrl && (React.createElement(EventImage, { hideImageOnMobile: hideImageOnMobile, className: "c-axs-event__image", url: eventImageUrl })),
        React.createElement(EventDetails, { hideImageOnMobile: hideImageOnMobile, className: "c-axs-event__details", marginLeft: eventImageUrl ? '16px' : 0, marginTop: eventImageUrl ? '12px' : 0 },
            React.createElement(React.Fragment, null,
                React.createElement("span", null, eventDate),
                eventDate && season ? (React.createElement("span", null,
                    ' ',
                    "| ",
                    React.createElement(Season, null, season))) : null,
                !eventDate && season ? (React.createElement(Season, { seasonColor: seasonColor }, season)) : null),
            React.createElement(EventName, { eventColor: eventColor }, eventName),
            extra && (React.createElement(Extra, { theme: theme, extraColor: extraColor }, extra)))));
};
exports.AXSEvent.defaultProps = {
    eventColor: colors_1.colors.GREY_650,
    extraColor: colors_1.colors.GREY_650,
    seasonColor: colors_1.colors.GREY_650,
};
exports.default = exports.AXSEvent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map